<script setup lang="ts" generic="T extends LinkType">
import type { NuxtLinkProps } from '#app';
import type { ButtonShellProps } from '../button';
import type { LinkShellTextProps } from './shell';

export type LinkType = 'button' | 'text' | 'custom';
type NuxtLinkPropsCustom = Omit<NuxtLinkProps, 'to'>;
type Options<TType extends LinkType> = {
  link?: NuxtLinkPropsCustom;
} & (TType extends 'button' ? ButtonShellProps : LinkShellTextProps);

const { type } = defineProps<{
  type: T;
  to: string;
  opts: Options<T>;
}>();
defineSlots<{ default: () => void; icon: () => void }>();
</script>

<template>
  <NuxtLink v-bind="{ ...(opts.link ?? {}), to }" draggable="false">
    <AppButtonShell v-if="type === 'button'" v-bind="opts as Options<'button'>">
      <slot />
      <template #icon>
        <slot name="icon" />
      </template>
    </AppButtonShell>
    <AppLinkShellText
      v-else-if="type === 'text'"
      v-bind="opts as Options<'text'>"
    >
      <slot />
      <template #icon>
        <slot name="icon" />
      </template>
    </AppLinkShellText>
    <slot v-else-if="type === 'custom'" />
  </NuxtLink>
</template>
